import * as React from 'react';
const Repair = (props: any) => {
  const { colorFill = '#003594' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
      <g mask="url(#a)">
        <path
          fill={colorFill}
          d="M10.004 12.075 6.475 8.517a3.279 3.279 0 0 1-.59.175c-.2.039-.411.058-.635.058-.972 0-1.799-.34-2.48-1.02-.68-.681-1.02-1.508-1.02-2.48 0-.35.049-.683.146-.999a3.83 3.83 0 0 1 .408-.897l2.13 2.13 1.05-1.05-2.13-2.13a3.83 3.83 0 0 1 .897-.408c.316-.097.649-.146.999-.146.972 0 1.799.34 2.48 1.02.68.681 1.02 1.508 1.02 2.48 0 .224-.02.435-.058.634-.04.2-.098.397-.175.591l3.558 3.53a.576.576 0 0 1 .175.422.576.576 0 0 1-.175.423l-1.225 1.225a.576.576 0 0 1-.423.175.576.576 0 0 1-.423-.175Z"
        />
      </g>
    </svg>
  );
};
export default Repair;
